import Affix from './src/affix.mjs';
export { affixEmits, affixProps } from './src/affix2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAffix = withInstall(Affix);

export { ElAffix, ElAffix as default };
//# sourceMappingURL=index.mjs.map
